'use client';
import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { useCarousel } from '@wwe-portal/ui/components/carousel';
import { NextArrowIcon } from '../../features/offer/component/next-arrow-icon';
import { FC } from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';

export const CarouselArrow: FC<{ className?: string }> = ({ className }) => {
  const { scrollNext, scrollPrev, canScrollNext, canScrollPrev } =
    useCarousel();
  const { api } = useCarousel();
  const nodes = api?.slideNodes();

  const totalNodes = nodes?.length;

  if (!totalNodes || totalNodes < 2) {
    return null;
  }

  return (
    <div
      className={cn(
        'pointer-events-none absolute inset-x-0 top-[50%] flex h-9 -translate-y-1/2 justify-between',
        className
      )}
    >
      {canScrollPrev && (
        <ClickableDiv
          className="pointer-events-auto absolute bottom-0 left-2 top-0 h-9 w-9 cursor-pointer self-center rounded-full bg-[#6a73b5] md:left-4"
          onClick={scrollPrev}
        >
          <NextArrowIcon className="rotate-180" />
        </ClickableDiv>
      )}

      {canScrollNext && (
        <ClickableDiv
          className="pointer-events-auto absolute bottom-0 right-2 top-0 h-9 w-9 cursor-pointer self-center rounded-full bg-[#6a73b5] md:right-4"
          onClick={scrollNext}
        >
          <NextArrowIcon />
        </ClickableDiv>
      )}
    </div>
  );
};
